import { Timestamp } from '@angular/fire/firestore';

export interface Grade {
  id?: string;
  gradeStatus: GradeStatus;
  gradeName: string;
  gradeYear: number;
  gradeAvgAge: number;
  teacherId?: string;
  teacherName?: string;
  teacherPhotoUrl?: string;

  groupId: string;

  created?: Timestamp;
  modified?: Timestamp;
}

export enum GradeStatus {
  active = 'active',
  archive = 'archive',
}
